import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { SpaceliftVcs } from "types/generated";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellText from "ds/components/Table/Row/CellText";

const SpaceliftVcsReposTableNameCell = ({
  item: repo,
  ...cellProps
}: TableSimpleCellProps<SpaceliftVcs>) => {
  return (
    <TableSimpleCell {...cellProps} role="rowheader">
      <TableCellText>{repo.name}</TableCellText>
    </TableSimpleCell>
  );
};

export default SpaceliftVcsReposTableNameCell;
